import { render, staticRenderFns } from "./parttablerow.vue?vue&type=template&id=66b8b270&"
import script from "./../../ts/projecttablerows/parttablerow.ts?vue&type=script&lang=js&"
export * from "./../../ts/projecttablerows/parttablerow.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/projecttablerows/parttablerow.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports